module.exports={
   "A1": ["s", "m", "g"],
   "A2": ["s", "m", "g"],
   "A3": ["s", "m", "g"],
   "A4": []
}